(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aotf-primary-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aotf-inline-plan')) {
  customElements.define('aotf-inline-plan', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const details = this.querySelector('details');
      const summary = details.querySelector('summary');
      this.addEventListener('click', event => {
        if (event.target.closest('summary') === summary) event.stopPropagation();
      }, true);
      details.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(details.open)));
      this.addEventListener('keyup', event => {
        if (event.key === 'Escape' && details.open) {
          event.stopPropagation();
          details.open = false;
          summary.focus();
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aotf-party-intake')) {
  customElements.define('aotf-party-intake', class extends HTMLElement {
    connectedCallback() {
      this.timer = requestAnimationFrame(() => this.initialize());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.timer);
      this.events?.abort();
      this.btaStorage?.remove();
      this.events = null;
    }
    initialize() {
      this.form = document.getElementById(this.dataset.formId);
      if (!this.form || this.events) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.count = this.querySelector('[data-party-count]');
      this.boatReference = crypto.randomUUID();
      this.error = this.querySelector('[data-party-error]');
      this.storage = this.form.querySelector('[data-party-properties]');
      this.count.addEventListener('change', () => this.sync(), options);
      this.addEventListener('input', () => this.sync(), options);
      this.addEventListener('change', () => this.sync(), options);
      const intercept = event => {
        const target = event.target instanceof Element ? event.target : null;
        const calendar = target?.closest('[data-aotf-calendar-action]');
        if (calendar?.dataset.productId === this.dataset.productId) { this.boatReference = crypto.randomUUID(); this.sync(); return; }
        const button = target?.closest('button[type="submit"],input[type="submit"]');
        const ours = event.type === 'submit' ? event.target === this.form :
          button?.form === this.form;
        if (!ours || this.validate()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      };
      document.addEventListener('click', intercept, { ...options, capture: true });
      document.addEventListener('submit', intercept, { ...options, capture: true });
      this.sync();
    }
    btaForm() {
      const first = document.querySelector('form[action*="/cart/add"]');
      if (first === this.form) return first;
      if (first?.querySelector('input[name="product-id"]')?.value !== this.dataset.productId ||
          first?.querySelector('input[name="id"]')?.value !== this.form.querySelector('input[name="id"]')?.value) return null;
      return first;
    }
    sync() {
      this.error.hidden = true;
      const selected = /^[123]$/.test(this.count.value);
      const extra = this.count.value === '3' ? 15000 : 0;
      const pricing = this.querySelector('[data-party-pricing]');
      if (pricing) {
        pricing.hidden = !selected;
        this.querySelector('[data-party-supplement]').hidden = extra === 0;
        for (const row of pricing.querySelectorAll('[data-party-rate]')) {
          const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: 'USD' }).format(cents / 100);
          const total = Number(row.dataset.baseCents) + extra;
          row.querySelector('[data-party-amounts]').textContent = row.dataset.template.replace('[total]', money(total)).replace('[deposit]', money(20000)).replace('[balance]', money(total - 20000));
        }
      }
      this.storage.replaceChildren();
      this.btaStorage?.replaceChildren();
      const btaForm = this.btaForm();
      if (!btaForm) return false;
      if (btaForm !== this.form && this.btaStorage?.parentElement !== btaForm) {
        this.btaStorage?.remove();
        this.btaStorage = document.createElement('div');
        this.btaStorage.hidden = true;
        this.btaStorage.dataset.partyMirror = this.dataset.formId;
        btaForm.append(this.btaStorage);
      }
      const count = Number(this.count.value);
      if (!Number.isInteger(count) || count < 1 || count > 3) return false;
      const properties = [['_AOTF party pricing', 'third-angler-v1'], ['_AOTF rate schedule', '2027-v1'], ['Attending angler count', String(count)], ['_AOTF boat reference', this.boatReference]];
      for (const [key, value] of properties) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${key}]`;
        input.value = value;
        if (key !== '_AOTF rate schedule') this.storage.append(input);
        if (btaForm !== this.form) this.btaStorage.append(input.cloneNode(true));
      }
      return true;
    }
    validate() {
      const synced = this.sync();
      if (!this.btaForm()) {
        this.error.textContent = this.dataset.formError;
        this.error.hidden = false;
        this.scrollIntoView({ block: 'center' });
        return false;
      }
      const invalid = Array.from(this.querySelectorAll('input, select')).find(input => !input.checkValidity());
      if (invalid || !synced) {
        this.error.textContent = this.dataset.requiredError;
        this.error.hidden = false;
        this.scrollIntoView({ block: 'center' });
        if (invalid) { invalid.focus(); invalid.reportValidity(); }
        return false;
      }
      return true;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
